import "../css/style.scss";

import ParallaxMotto from "./modules/ParallaxMotto";
import ShowcaseSlider from "./modules/ShowcaseSlider";
import MapReloud from "./modules/MapReloud";

document.addEventListener("DOMContentLoaded", function () {
  var path = window.location.pathname;

  if (path === "/kontakt" || path === "/kontakt/") {
    console.log("Kontakt");
    var mapReloud = new MapReloud();
  }

  if (path === "" || path === "/") {
    console.log("Main");
    var parallaxMotto = new ParallaxMotto();
    var showcaseSlider = new ShowcaseSlider();
  }
});
